export default __webpack_public_path__ + "static/media/IN.8f56f8da.svg";